<template>
  <div class="container">
    <p v-if="progress == 100">لطفا چند لحظه منتظر بمانید ...</p>
    <p v-else>
      در حال بارگذاری: <strong>{{ progress + "%" }}</strong>
    </p>
  </div>
</template>

<script>
export default {
  name: "Progress",
  props: {
    progress: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000000;

  p {
    font-size: 1.1rem;
  }
}
</style>